import React from "react";
import { Button } from "@material-ui/core";
import shortfetch from "../../../components/data/fetch.jsx";

const DeleteModelData = (props) => {
  const { history, Change_State, ModelID } = props;

  const delete_model_data = async () => {
    let post_json = {
      type: "delete_model_data_DINH",
      currentID: ModelID,
      auth: localStorage.getItem("auth"),
    };

    let data = await shortfetch(post_json);

    if (data.geslaagd) {
      let newID = Number(ModelID);
      history.push("/Form/Modellen/Die/Ik/Niet/Heb/" + ModelID);
      Change_State(newID);
    } else {
      alert("Er is iets fout gegaan tijdens het opslaan.");
    }
  };

  const confirm = () => {
    if (window.confirm("Weet je zeker dat je het model wilt verwijderen?")) {
      delete_model_data();
    }
  };

  return (
    <Button
      onClick={() => confirm()}
      style={{ background: "#D3D3D1", width: "40%", marginLeft: "5%" }}
    >
      Model {ModelID} Verwijderen
    </Button>
  );
};

export default DeleteModelData;
